<button 
  [class]="buttonClass"
  (click)="onRevealClick($event)" 
  [disabled]="isRevealing"
  [matTooltip]="'candidates.anonymized.revealTooltip' | translate" 
  matTooltipPosition="above">
  
  <mat-icon *ngIf="!isRevealing" class="unlock-attempt">lock_open</mat-icon>
  <mat-icon *ngIf="isRevealing" class="spinning">refresh</mat-icon>
  
  <span *ngIf="showText && !iconOnly">
    {{ isRevealing ? ('candidates.anonymized.revealing' | translate) : ('candidates.anonymized.reveal' | translate) }}
  </span>
</button>